'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_CONTEXT_PROPERTY_GET = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Event = require('../Core/Event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fetch a property of a context object
 *
 * @readonly
 * @type {string}
 */
var EVENT_CONTEXT_PROPERTY_GET = exports.EVENT_CONTEXT_PROPERTY_GET = 'context.property.get'; /**
                                                                                               * This module exports events available when the application is hosted by a UI Tab component
                                                                                               *
                                                                                               * @module Context/eventsTicket
                                                                                               */

var events = {
  EVENT_CONTEXT_PROPERTY_GET: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @enum
 * @readonly
 * @type {{EVENT_CONTEXT_PROPERTY_GET: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/eventsObject.js
// module id = 106
// module chunks = 0